import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { TSDCreateData, TSDListItem } from '@e-origin/contracts';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useCreateTSD = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: TSDCreateData): Promise<TSDListItem> => {
      const { file, ...payload } = data;

      const formData = new FormData();
      formData.append('data', JSON.stringify(payload));

      if (file) {
        formData.append('file', file);
      }

      const result = await apiClient.tsd.createTsd.mutation({
        body: formData,
      });

      if (result.status !== 200) throw result.body;
      return result.body.data.createdTsd as TSDListItem;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['temporary-storages'] });
      toast.success(`New temporary storage was uploaded!`);
    },
    onError: (error) => {
      const originalError = (error as any).response?.data?.originalError;
      showErrorToast(error, originalError || `Error uploading the temporary storage!`);
    },
  });
};
